import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

const QUERY_KEY = 'GET_PLAN_CIP_CONFIG';

interface Params {
  enabled?: boolean;
}
const useGetPlanCIPConfigQuery = (params: Params) => {
  const { data, isLoading, isSuccess } = useQuery(
    [QUERY_KEY, params?.enabled],
    () => api.get(API_URL.METRICS_CIP_CONFIG),
    {
      retry: 0,
      enabled: params.enabled,
    }
  );
  const formattedData = useMemo(() => {
    const currentData = data?.data;
    return {
      isShowed: currentData?.show_cip_metrics || false,
      CIPAccountDelayDays: currentData?.cip_account_closure_delay_days,
    };
  }, [data?.data]);
  return {
    data: formattedData,
    isLoading,
    isSuccess,
  };
};
export default useGetPlanCIPConfigQuery;
